export enum URLs {
  HOME = "/",
  SELECCIONAR_PROCESO = "/entrega-documentos",
  SELECCIONAR_PROCESO_AYUDA = "/entrega-documentos/ayuda",
  CARGA_DOCUMENTAL = "/entrega-documentos/carga-documentos",
  ESTADO_DOCUMENTOS = "/entrega-documentos/estado-solicitud"
}

export const TiposIdentificacion = [
  {id: "CC", descripcion: "Cédula de ciudadanía"},
  {id: "CD", descripcion: "Carné diplomático"},
  {id: "CE", descripcion: "Cédula de extranjería"},
  {id: "PAS", descripcion: "Pasaporte"},
  {id: "PE", descripcion: "Permiso especial"},
  {id: "PT", descripcion: "Permiso temporal"},
  {id: "TI", descripcion: "Tarjeta de Identidad"},
  {id: "RCN", descripcion: "Registro civil"},
  {id: "NIT", descripcion: "NIT"}
];

export const TiposArchivoPermitidos =
  "image/png," +
  "image/jpg," +
  "image/jpeg," +
  "image/tiff," +
  "application/pdf," +
  "application/msword," +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
  "application/vnd.ms-excel," +
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
;
